import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

import { EPG_SURFACE_OPACITY } from "$src/core/constants/epg-grid";
import opacity from "$src/core/utils/color/opacity";

const stylesheet = StyleSheet.create(({ colors, spacing, border }) => ({
  // Web/desktop horizontal row (EPGChannelSelector.web)
  itemFlex: {
    flex: 1,
  },
  // SnapPickerItem centres its child, so the row needs its own full width.
  content: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    gap: spacing(2),
    width: "100%",
  },
  logo: {
    width: spacing(12),
    height: spacing(10),
  },
  title: {
    flexShrink: 1,
    color: colors.foregroundDefault,
    textAlign: "center",
    _web: {
      cursor: "pointer",
    },
  },
  titleActive: {
    color: colors.foregroundOnInverted,
  },

  // Mobile dropdown: full-width surface chip (Figma).
  trigger: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(2),
    height: spacing(14),
    marginHorizontal: spacing(4),
    paddingHorizontal: spacing(4),
    borderRadius: border.radius.md,
    backgroundColor: opacity(colors.foregroundDefault, EPG_SURFACE_OPACITY),
  },
  triggerContent: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: spacing(2),
    paddingLeft: spacing(8),
  },
  triggerTitle: {
    flexShrink: 1,
    color: colors.foregroundDefault,
    textAlign: "left",
  },
  icon: {
    width: spacing(6),
    height: spacing(6),
    color: colors.foregroundDefault,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(3),
    minHeight: spacing(14),
    paddingVertical: spacing(3),
  },
  rowTitle: {
    flex: 1,
    minWidth: 0,
    color: colors.foregroundDefault,
  },
}));

const initialTheme = UnistylesRuntime.getTheme();

// Width-only so the CDN preserves the logo's real aspect ratio (KAHI-268).
export const IMAGE_DIMENSIONS = {
  logo: [{ width: initialTheme.spacing(12) }],
};

export default stylesheet;
